export default {
    dependencies: ['$element', 'trackingservice', 'userservice'],
    callable(element, trackingService, userService) {
        const conversationElements = element.querySelectorAll(
            '[data-finnbox-conversation]'
        );

        init();
        return {
            getConversationElement,
        };

        function init() {
            trackingService.deprecatedTrackEvent('finnbox_view_inbox');
            setupEvents();
            invalidateCounterCacheIfNeccesary();
            window.setTimeout(removeRefParameter, 500);
        }

        function invalidateCounterCacheIfNeccesary() {
            if (hasUnreadConversations()) {
                userService.forceRefresh();
            }
        }

        function removeRefParameter() {
            const url = new URL(document.baseURI);
            url.searchParams.delete('ref');
            history.replaceState(null, null, url);
        }

        function setupEvents() {
            for (let i = 0; i < conversationElements.length; i++) {
                conversationElements[i].addEventListener(
                    'click',
                    handleConversationClick
                );
            }
        }

        function getConversationElement(index) {
            return conversationElements[index];
        }

        function handleConversationClick(event) {
            const conversation = event.currentTarget;
            if (conversation.classList.contains('bg-ice')) {
                conversation.classList.remove('bg-ice');
                userService.forceRefresh();
            }
        }

        function hasUnreadConversations() {
            return element.querySelector('[data-finnbox-unread]') !== null;
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/finnboxConversations.js